import { cmsCLient } from '@/services/axiosConfig'
import { HomePageContent } from './types'

export type GetHomePageContentRes = HomePageContent

export type GetHomePageContents = () => Promise<GetHomePageContentRes>

export const getHomePageContents: GetHomePageContents = async () => {
  try {
    const response = await cmsCLient.get('/contents/home')
    return response.data
  } catch (e: any) {
    return e.message
  }
}
